export type RuntimeStateUpdate<TRuntimeState> =
	| TRuntimeState
	| ((currentRuntimeState: TRuntimeState) => TRuntimeState);

export type RuntimeCallbackCarrier<TRuntimeState> = {
	episodeSoundDefault?: boolean;
	/** The route the viewer just left through a portal; a space may place the viewer beside the portal leading back there. */
	arrivalOrigin?: string;
	runtimeCallbacks?: Record<string, unknown> & {
		onRuntimeStateChange?: (updateRuntimeState: RuntimeStateUpdate<TRuntimeState>) => void;
	};
};

export function withRuntimeStateChangeCallback<TRuntimeState, TConfig extends RuntimeCallbackCarrier<TRuntimeState>>(
	config: TConfig,
	onRuntimeStateChange: (updateRuntimeState: RuntimeStateUpdate<TRuntimeState>) => void,
): TConfig {
	return {
		...config,
		runtimeCallbacks: {
			...(config.runtimeCallbacks ?? {}),
			onRuntimeStateChange,
		},
	};
}
